import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogModule } from '@angular/material/dialog';

import { MtnaDialogModule } from '@mtna/lib-ui';

import { RdsFooterItemTypePipe } from './app-footer-item-type.pipe';
import { RdsAppFooterComponent } from './app-footer.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MtnaDialogModule, MatDialogModule],
  exports: [RdsAppFooterComponent],
  declarations: [RdsAppFooterComponent, RdsFooterItemTypePipe],
})
export class RdsAppFooterModule {}

export * from './app-footer.component';
